import React, { useState } from "react";
import { ScaleLoader } from "react-spinners";
import { Modal } from "react-bootstrap";
import { AxiosPost } from "../../../../../context/UserContext";
import { pushNotify } from "../../../../../services/NotifyService";
import { useEffect } from "react";
import ReactDataGrid from '@inovua/reactdatagrid-community'
import '@inovua/reactdatagrid-community/index.css'
import Button from '@inovua/reactdatagrid-community/packages/Button';
import SelectFilter from '@inovua/reactdatagrid-community/SelectFilter'
import DateFilter from '@inovua/reactdatagrid-community/DateFilter'
import moment from "moment";
import CreatableSelect from 'react-select/creatable';
import * as XLSX from 'xlsx';

function TransportLogsTable() {
    const [isLoading, setIsLoading] = useState(false);
    const [deleteModal, setDeleteModal] = useState({ show: false, id: null });
    const [transportLogs, setTransportLogs] = useState([]);
    const gridStyle = { height: 'calc(100vh - 16.5rem)', marginTop: 10 };
    const [gridRef, setGridRef] = useState(null)
    const initialFormData = { activity_type: "shoot", vehicle_number: '', vehicle_description: '', shoot_date: moment().format('YYYY-MM-DD'), user_department: '', vehicles_used: '',driver_name:'',remarks:'' }
    const [formData, setFormData] = useState([initialFormData])
    const [customsl, setCustomSl] = useState('0')
    window.moment = moment
    const [isLoading2, setIsLoading2] = useState(false)
    const [vehicleOptions, setVehicleOptions] = useState([])
    const [uploadData, setUploadData] = useState(null)

    const filterValue = [
        { name: "num_row", operator: 'eq', type: 'number', value: null },
        { name: 'vehicle_number', operator: 'startsWith', type: 'string', value: '' },
        { name: 'vehicle_description', operator: 'startsWith', type: 'string', value: null },
        { name: 'activity_type', operator: 'startsWith', type: 'string', value: null },
        { name: 'shoot_date', operator: 'after', type: 'date', value: '' },
        { name: 'user_department', operator: 'startsWith', type: 'string', value: '' },
    ];

    const columns = [
        { name: 'num_row', header: 'sl', type: 'number', editable: false,minWidth:200 },
        { name: 'vehicle_number', header: 'Vehicle Number',minWidth:200 },
        { name: 'vehicle_description', header: 'Vehicle Description',minWidth:200 },
        {
            name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date',minWidth:200,
            dateFormat: 'YYYY-MM-DD',
            filterEditor: DateFilter,
        },
        { name: "activity_type", defaultFlex: 2, header: "Activity Type",minWidth:200 },
        { name: 'user_department', defaultFlex: 2, header: 'User Department' ,minWidth:200},
        { name: 'driver_name', defaultFlex: 2, header: 'Driver Name',minWidth:200 },
        { name: 'remarks', defaultFlex: 2, header: 'remarks',minWidth:200 },
        {
            name: 'sl', defaultFlex: 2, header: 'Actions', editable: false,minWidth:200,
            render: ({ value }) =>
                <button className="btn btn-sharp" style={{ color: "red" }} onClick={() => showDeleteForm(value)}><i class="fas fa-trash-alt"></i></button>
        },
    ];

    const columns2 = [
        { name: 'vehicle_number', header: 'Vehicle Number' },
        { name: 'vehicle_description', header: 'Vehicle Description' },
        { name: 'shoot_date', defaultFlex: 2, header: 'Shoot Date' },
        { name: "activity_type", defaultFlex: 2, header: "Activity Type" },
        { name: 'user_department', defaultFlex: 2, header: 'User Department' },
        { name: 'driver_name', defaultFlex: 2, header: 'Driver Name' },
        { name: 'remarks', defaultFlex: 2, header: 'remarks' },
    ]

    const exportCSV = () => {
        const columns = gridRef.current.visibleColumns;

        const header = columns.map((c) => c.name).join(',');
        const rows = gridRef.current.data.map((data) => columns.map((c) => data[c.id]).join(','));

        const contents = [header].concat(rows).join('\n');
        const blob = new Blob([contents], { type: 'text/csv;charset=utf-8;' });

        downloadBlob(blob);
    };

    const updateCustomSl = (logs, date) => {
        let temp = 0
        logs.map((log) => {
            if (log.shoot_date == date && log.num_row > temp) {
                console.log(log.num_row)
                temp = parseInt(log.num_row)

            }
        })
        setCustomSl(temp)
    }

    const downloadBlob = (blob, fileName = 'grid-data.csv') => {
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);

        link.setAttribute('href', url);
        link.setAttribute('download', fileName);
        link.style.position = 'absolute';
        link.style.visibility = 'hidden';

        document.body.appendChild(link);

        link.click();

        document.body.removeChild(link);
    };

    useEffect(() => {
        fetchLogsData()
    }, [])

    const fetchLogsData = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('fetch_transport_logs.php')
            if (data.success) {
                setTransportLogs(data.logs)
                updateCustomSl(data.logs, moment().format("YYYY-MM-DD"))
            }
            else pushNotify("error", "Error", data.error)
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const showDeleteForm = (index) => {
        setDeleteModal({ show: true, id: index });
    }

    const deleteItem = async () => {
        setIsLoading(true);
        try {
            const data = await AxiosPost('delete_transport_log.php', { sl: deleteModal.id })
            console.log(data);
            if (data.success) pushNotify('success', 'Success', 'Item Deleted Successfully');
            else pushNotify('error', 'Error', data.error);
            setDeleteModal({ show: false, id: null });
            await fetchLogsData();
            console.log(data);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const cancelDelete = () => {
        setDeleteModal({ show: false, id: null });
    }

    const onChangeHandler = (e, index) => {
        let old = [...formData]
        old[index] = { ...old[index], [e.target.name]: e.target.value }
        setFormData(old)
    }

    const addTransportLog = async (e) => {
        e.preventDefault()
        try {
            const data = await AxiosPost('add_transport_log.php', formData)
            console.log(data);
            if (data.success) {
                setFormData([initialFormData])
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const removeRow = (i) => {
        let old = []
        formData.map((data, index) => index == i ? null : old.push(data))
        setFormData(old)
    }

    const datechangehandler = (e) => {
        let old = [...formData]
        old.map((data, index) => {
            old[index].shoot_date = e.target.value
        })
        setFormData(old)
    }

    const fetchVehicleOptions = async () => {
        try {
            const data = await AxiosPost('fetch_vehicle_options.php')
            console.log(data);
            if (data.success) {
                setVehicleOptions(data.options)
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        fetchVehicleOptions()
    }, [])

    const onEditComplete = async (e) => {
        try {
            setIsLoading(true)
            let formData = { ...e.data, [e.columnId]: e.value }
            const data = await AxiosPost('update_transport_logs.php', formData)
            if (data.success) {
                await fetchLogsData()
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const handleUpload = (e) => {
        console.log("working")
        e.preventDefault()
        var files = e.target.files, f = files[0];
        const reader = new FileReader();
        reader.onload = (evt) => {
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: 'binary' });
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            const data = XLSX.utils.sheet_to_json(ws, { header: ["shoot_date", "activity_type", "vehicle_number", "vehicle_description",
            "driver_name","user_department","remarks","vehicles_used"], blankrows: false, defval: '' });
            data.map((input, index) => {
                input.shoot_date = moment(input.shoot_date, "DD-MM-YYYY").format("YYYY-MM-DD")
            })
            data.shift()
            data.shift()
            console.log(data)
            setUploadData(data)
        };
        reader.readAsBinaryString(f);
    }

    const uploadExcelData = async () => {
        setIsLoading(true)
        try {
            const data = await AxiosPost('add_transport_log_excel.php', uploadData)
            console.log(data);
            if (data.success) {
                await fetchLogsData()
                setUploadData(null)
            }
            else pushNotify('error', 'Error', data.error);
        } catch (err) {
            pushNotify("error", "Error", "Server Error!");
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    return (
        <div className="col-lg-12 col-md-12 col-sm-12">
            <div>
                {
                    isLoading ? <ScaleLoader cssOverride={{ "display": "flex", "justifyContent": "center", "alignItems": "center" }} /> :
                        <>
                            <div>
                                <input className="form-control mb-2 mr-2" style={{ "width": "fit-content", display: "inline" }} type="file" onChange={handleUpload} id="demo" accept=".xls,.xlsx"></input>
                                <Button style={{ "margin-left": "10px" }} onClick={uploadExcelData}>
                                    Upload
                                </Button>
                                {uploadData == null ? null :
                                    <ReactDataGrid
                                        idProperty="id"
                                        style={gridStyle}
                                        columns={columns2}
                                        pagination="local"
                                        dataSource={uploadData}
                                        defaultLimit={25}
                                        handle={setGridRef}
                                        loading={isLoading}
                                    />
                                }
                            </div>
                            <form className='custom-form-wrapper mb-2' onSubmit={(e) => addTransportLog(e)}>
                                <div className="custom-form-inner">
                                    <div className='custom-form-cell'>
                                        <div className='custom-form-label'>
                                            Shoot Date <span className="text-danger">*</span>
                                        </div>
                                        <div className='custom-form-input'>
                                            <input type="date" value={formData[0].shoot_date} name="shoot_date" onChange={(e) => { datechangehandler(e); updateCustomSl(transportLogs, e.target.value) }} required />
                                        </div>
                                    </div>
                                </div>
                                {formData.map((data, index) => (
                                    <div className='custom-form-inner'>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Sl
                                                <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); setFormData([...formData, initialFormData]) }} ><i className="fas fa-plus"></i></button>
                                                {index == 0 ? null : <button className="btn btn-primary tp-btn sharp custom-add-button" onClick={(e) => { e.preventDefault(); removeRow(index) }} ><i className="fas fa-minus"></i></button>}
                                            </div>
                                            <div className='custom-form-input'>
                                                <div className="form-control">{customsl + index + 1}</div>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Activity Type
                                            </div>
                                            <div className='custom-form-input'>
                                                <select value={formData[index].activity_type} name="activity_type" onChange={(e) => onChangeHandler(e, index)} >
                                                    <option value="shoot">Shoot</option>
                                                    <option value="non-shoot">Non Shoot</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Vehicle Number <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <CreatableSelect
                                                    onChange={(e) => { let old = [...formData]; old[index] = { ...old[index], "vehicle_number": e }; setFormData(old) }}
                                                    options={vehicleOptions}
                                                    value={formData[index].vehicle_number}
                                                    isDisabled={isLoading2}
                                                    isLoading={isLoading2}
                                                    onCreateOption={(e) => { let temp = [...formData]; temp[index].vehicle_number = { value: e, label: e }; setFormData(temp) }}
                                                />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Vehicle Description <span className="text-danger">*</span>
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].vehicle_description} name="vehicle_description" onChange={(e) => onChangeHandler(e, index)} required />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                User Department
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].user_department} name="user_department" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Driver Name
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].driver_name} name="driver_name" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                        <div className='custom-form-cell'>
                                            <div className='custom-form-label'>
                                                Remarks
                                            </div>
                                            <div className='custom-form-input'>
                                                <input type="text" value={formData[index].remarks} name="remarks" onChange={(e) => onChangeHandler(e, index)} />
                                            </div>
                                        </div>
                                    </div>))}
                                <Button className="mt-2 mb-2">
                                    Add Transport Log
                                </Button>
                            </form>
                        </>
                }

            </div>

            <>
                <Button onClick={fetchLogsData}>
                    Sync Data
                </Button>
                <Button style={{ marginLeft: 10 }} onClick={exportCSV}>
                    Export CSV
                </Button>
                <ReactDataGrid
                    idProperty="id"
                    style={gridStyle}
                    columns={columns}
                    pagination="local"
                    dataSource={transportLogs}
                    defaultLimit={25}
                    defaultFilterValue={filterValue}
                    handle={setGridRef}
                    editable={true}
                    onEditComplete={onEditComplete}
                    loading={isLoading}
                />
            </>
            <Modal className="fade" show={deleteModal.show} centered>
                <Modal.Header>
                    <Modal.Title>Delete Log?</Modal.Title>
                    <button
                        onClick={cancelDelete}
                        className="btn-close"
                    >
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Are you sure you want to delete the Log?</h4>
                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={deleteItem}
                        className="btn btn-danger"
                    >
                        Delete
                    </button>
                    <button className="btn btn-primary" onClick={cancelDelete}>Cancel</button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default TransportLogsTable;